import * as carCategoryService from '../../services/carCategory.service';

const state = {
    carCategorySingle:{},
    carCategoryPaginateData:{},
    carCategoryPaginate:{},
    carCategoryDropdown:[],
};

const getters = {
    getCarCategorySingle:state => (state.carCategorySingle),
    getCarCategoryPaginateData:state => (state.carCategoryPaginateData),
    getCarCategoryPaginate:state => (state.carCategoryPaginate),
    getCarCategoryDropdown:state => (state.carCategoryDropdown),
};

const actions = {
    async fetchCarCategorySingle({ commit }, obj){
        try {

          const response = await carCategoryService.single(obj.id);
          commit('setCarCategorySingle', response.data);

        } catch (error) {
            console.log('something wrong - fetchCarCategorySingle', error);
        }
    },

    async fetchCarCategoryPaginate({ commit }, obj){
        commit('setCarCategoryPaginate', obj)
        try {

            const response = await carCategoryService.listPage(obj);
            commit('setCarCategoryPaginateData', response.data);
            
        } catch (error) {
            console.log('something wrong - fetchCarCategoryPaginate', error);
        }
    },

    async fetchCarCategoryDropdown({ commit }){
        try {

            const response = await carCategoryService.dropdown();
            commit('setCarCategoryDropdown', response.data);
            
        } catch (error) {
            console.log('something wrong - fetchCarCategoryDropdown', error);
        }
    },
};

const mutations = {
    setCarCategorySingle:(state, res) => (
        state.carCategorySingle =  res
    ),
    setCarCategoryPaginateData:(state, res) => (
        state.carCategoryPaginateData =  res
    ),
    setCarCategoryPaginate:(state, res) => (
        state.carCategoryPaginate =  res
    ),
    setCarCategoryDropdown:(state, res) => (
        state.carCategoryDropdown =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}